import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { UserMessagesService } from "./shared/user-messages/user-messages.service";





@Injectable({
    providedIn:'root'
})
export class HttpTokenInterceptor implements HttpInterceptor{

    constructor(
        private userMessagesService: UserMessagesService,
        private router: Router
    ){ }

    intercept(request:HttpRequest<any>, next:HttpHandler):Observable<HttpEvent<any>>
    {
        let handleResponse: Observable<HttpEvent<any>>;
        let authToken = JSON.parse(localStorage.getItem("token"));
        if(authToken)
        {
            const AUTH_REQUEST = request.clone({headers:request.headers.set("Authorization", "Bearer "+ authToken.token)});
            handleResponse = next.handle(AUTH_REQUEST);
        }
        else
        {
            handleResponse = next.handle(request);
        }
        return handleResponse.do(_ => {},
           (error:any)=>{
                if(error.status == 401 || error.status == 403)// unauthorized or forbidden
                {
                    this.userMessagesService.setErrorMessage("ארעה שגיאה בעת ביצוע הפעולה. נא לבצע כניסה מחדש ולנסות שוב");
                    if(authToken && authToken.role == 1)
                    {
                        this.router.navigate(["login/admin"]);
                    }
                    else
                    {
                        this.router.navigate(["login"]);
                    }
                }
           });
    }
}

